import { createI18n } from 'vue-i18n'

import { LanguageEnum } from '@/constants'

import en from './en.json'
import zhCn from './zh-cn.json'

export const KEY_MISSING_TRANSLATIONS = 'missingKeys'

const language = {
  [LanguageEnum.EN]: en,
  [LanguageEnum.ZH_CN]: zhCn
}

console.log('language:', language)

const availableLangs = Object.keys(language)

/**
 * Get the default language based on localStorage or browser language
 */
const getDefaultLanguage = (): LanguageEnum => {
  // Check localStorage first
  if (window.localStorage.language && availableLangs.indexOf(window.localStorage.language as LanguageEnum) >= 0) {
    return window.localStorage.language as LanguageEnum
  }

  // Check browser language
  if (navigator.language && availableLangs.indexOf(navigator.language as LanguageEnum) >= 0) {
    return navigator.language as LanguageEnum
  }

  // Fallback to English
  return LanguageEnum.EN
}

const defaultLanguage = getDefaultLanguage()

export const i18n = createI18n({
  // Use Composition API, Set to false
  allowComposition: true,
  legacy: false,
  locale: defaultLanguage,
  fallbackLocale: LanguageEnum.EN,
  messages: language,
  missing: (_locale: string, key: string) => {
    // handle translation missing
    const module = key.slice(0, key.indexOf('.'))
    const transKey = key.split('.').pop()

    if (!transKey) return ''

    const tokens = transKey.split('_')
    let transValue = ''
    for (const t of tokens) {
      transValue += t.charAt(0).toUpperCase() + t.slice(1) + ' '
    }

    const missingKeysStr = localStorage.getItem(KEY_MISSING_TRANSLATIONS)

    let missingKeys: Record<string, Record<string, string>> = {}

    try {
      missingKeys = missingKeysStr ? JSON.parse(missingKeysStr) : {}
      if (!missingKeys) missingKeys = {}
    } catch {
      missingKeys = {}
    }

    if (!missingKeys[module]) missingKeys[module] = {}

    missingKeys[module][transKey] = transValue.trim()

    localStorage.setItem(KEY_MISSING_TRANSLATIONS, JSON.stringify(missingKeys))

    console.log('!!!missing key!!! ' + module)
    console.log(transKey + ': ' + "'" + transValue.trim() + "',")
  }
})

/**
 * Set the locale
 */
export const setLocale = (locale?: LanguageEnum) => {
  console.log('setLocale', i18n, locale)

  if (locale === undefined) {
    i18n.global.locale.value = defaultLanguage
  } else {
    i18n.global.locale.value = locale
  }

  window.localStorage.language = i18n.global.locale.value
}

/**
 * Get the current locale
 */
export const getLocale = () => {
  return i18n.global.locale
}
